module.exports = __webpack_public_path__ + "static/img/login-photo.d16a3b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/login-photo.jpg
// module id = rgb/
// module chunks = 1